import React, { useEffect, useRef, useState } from "react";
import "./AttachmentList.scss";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { useQuery } from "@tanstack/react-query";
import {
  ActivateUser,
  DeactivateUser,
  UserResetPassword,
  deleteStaff,
  getAttachmets,
  getSignupReDetail,
  getUser,
  listStaff,
  staffId,
} from "../../../../apiCall";
import toast from "react-hot-toast";
import { FormateDate } from "../../../../utils/FormateDate";
import { NewPasswordModal } from "../../../../components/Modals/NewPasswordModal";
import { ConfirmationModal } from "../../../../components/Modals/ConfirmationModal";
import Attachments from "../../../../components/Attachments/Attachments";
import { useParams } from "react-router-dom";
import { useStateValue } from "../../../../StateProvider";

const AttachmentList = ({
  setActiveTab,
  setTab,
  setAttachmentCount,
  attchmentId,
  setAttchmentId,
  setEditAttchmentId,
  searchQuery,
  setSearchQuery,
  attachmentType,
  TranType,
  AttchType,
  staffId,
}) => {
  const { taskId, subtaskId, projectId, temId } = useParams();

  const searchInput = useRef(null);
  const [{ userInfo,sysConfig }, dispatch] = useStateValue();

  const fetchattachmentList = async () => {
    // Perform the API call to fetch company info
    dispatch({ type: "SET_LOADING", status: true });
    try {
      let response;
      if (staffId) {
        response = await getAttachmets(TranType, staffId, AttchType);
      } else if (attachmentType === "task") {
        response = await getAttachmets(TranType, taskId, AttchType);
      } else if (attachmentType === "project") {
        response = await getAttachmets(TranType, projectId, AttchType);
      } else if (
        attachmentType === "subTask" ||
        attachmentType === "subTaskTemp"
      ) {
        response = await getAttachmets(TranType, subtaskId, AttchType);
      } else if (attachmentType === "taskTemp") {
        response = await getAttachmets(TranType, temId, AttchType);
      } else if (attachmentType === "projectTemp") {
        response = await getAttachmets(TranType, projectId, AttchType);
      } else if (attachmentType === "company") {
        response = await getAttachmets(TranType, 1, AttchType);
      }

      if (response?.status === 200) {
        setAttchmentList(response.data.data);
        setFilteredData(response.data.data);
        refetch();
      } else if(response?.response?.status)  {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
    dispatch({ type: "SET_LOADING", status: false });
  };
  const { isLoading, isFetching, data, refetch } = useQuery({
    queryKey: ["attachment-list"],
    queryFn: () => fetchattachmentList(),
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [attchmentList, setAttchmentList] = useState([]);
  // const [attchmentId, setAttchmentId] = useState();

  // ********************************************************************* filter Data *************************************************
  // const [searchQuery, setSearchQuery] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    searchInput.current.value = searchQuery;
    filterData(searchQuery);
    setCurrentPage(1);
  }, [searchQuery]);

  useEffect(() => {
    const startIdx = (currentPage - 1) * Number(sysConfig["Rows in MultiLine List"]);
    setCurrentItems(filteredData.slice(startIdx, startIdx + Number(sysConfig["Rows in MultiLine List"])));
    setTotalPages(Math.ceil(filteredData.length / Number(sysConfig["Rows in MultiLine List"])));
  }, [currentPage, filteredData]);

  useEffect(() => {
    filterData(searchQuery);
    setTotalPages(Math.ceil(filteredData.length / Number(sysConfig["Rows in MultiLine List"])));
    const totalPageCount = Math.ceil(filteredData.length / Number(sysConfig["Rows in MultiLine List"]));
    if (totalPageCount !== 0 && totalPageCount < currentPage) {
      setCurrentPage(totalPageCount);
    }
  }, [attchmentList]);

  const handleSearch = (e) => {
    // const query = e.target.value.toLowerCase();
    const query = searchInput.current.value.toLowerCase();
    setSearchQuery(query);
    refetch();
  };

  useEffect(() => {
    if (attchmentId && filteredData.length > 0) {
      const targetIndex = filteredData.findIndex(
        (item) => item.ID === parseInt(attchmentId)
      );
      if (targetIndex !== -1) {
        const pageNumber = Math.floor(targetIndex / Number(sysConfig["Rows in MultiLine List"])) + 1;
        setCurrentPage(pageNumber);
        // setCurrentItems(
        //   filteredData.slice(targetIndex, targetIndex + Number(sysConfig["Rows in MultiLine List"]))
        // );
      }
    }
  }, [attchmentId, filteredData]);

  const filterData = (query) => {
    let filtered = attchmentList;

    if (query) {
      filtered = filtered.filter(
        (item) =>
          item.Dscr.toLowerCase().includes(query) ||
          item.DocNm.toLowerCase().includes(query)
      );
    }

    setFilteredData(filtered);
    // setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // ************************************************************* reset password modal **********************************

  const [show, setShow] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const handleClose = () => {
    setShow(false);
    setNewPassword("");
  };
  const handleShow = () => setShow(true);

  return (
    <>
      <Attachments
        filteredData={filteredData}
        refetch={refetch}
        setActiveTab={setActiveTab}
        setTab={setTab}
        handleSearch={handleSearch}
        searchInput={searchInput}
        setAttachmentCount={setAttachmentCount}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        totalPages={totalPages}
        currentItems={currentItems}
        setEditAttchmentId={setEditAttchmentId}
        attchmentId={attchmentId}
        setAttchmentId={setAttchmentId}
        // removeSelection={removeSelection}
        isLoading={isLoading}
      />
    </>
  );
};

export default AttachmentList;
